export enum FlexResetPeriod {
    MONTHLY = 'monthly',
    WEEKLY = 'weekly',
    DAILY = 'daily',
}

export enum FlexResetPeriodCode {
    P1M = 'P1M',
    P1W = 'P1W',
    P1D = 'P1D',
}
